"use strict";

exports.__esModule = true;
exports.monthComparator = monthComparator;
exports.dateComparator = dateComparator;
exports["default"] = isDateInSet;

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.is-array");

var _end_of_month = _interopRequireDefault(require("date-fns/end_of_month"));

var _is_date = _interopRequireDefault(require("date-fns/is_date"));

var _is_equal = _interopRequireDefault(require("date-fns/is_equal"));

var _is_within_range = _interopRequireDefault(require("date-fns/is_within_range"));

var _start_of_month = _interopRequireDefault(require("date-fns/start_of_month"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function monthComparator(a, b) {
  var monthStart = (0, _start_of_month["default"])(b);
  var monthEnd = (0, _end_of_month["default"])(b);
  return (0, _is_within_range["default"])(a, monthStart, monthEnd);
}

function dateComparator(a, b) {
  return (0, _is_equal["default"])(a, b);
}

function isDateInSet(date, set, comparator) {
  if (comparator === void 0) {
    comparator = dateComparator;
  }

  if (date && set) {
    if ((0, _is_date["default"])(set)) {
      return comparator(date, set);
    }

    if (Array.isArray(set)) {
      return set.some(function (dateInSet) {
        return comparator(date, dateInSet);
      });
    }

    if (typeof set === 'function') {
      return set(date);
    }
  }

  return false;
}